/**
 * OperationalStatusBadge — action-oriented lead status (Sprint 8.8).
 */

import React from "react";
import { Chip, Tooltip } from "@mui/material";
import { styled } from "@mui/material/styles";
import {
  getLeadOperationalBucket,
  getLeadOperationalLabel,
} from "../services/leadOperationalStatus.js";

const StyledChip = styled(Chip)({
  fontWeight: 600,
  fontSize: "0.75rem",
  height: "24px",
  maxWidth: "100%",
  "& .MuiChip-label": {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    display: "block",
    paddingLeft: 8,
    paddingRight: 8,
  },
  "&.ops-new": {
    backgroundColor: "rgba(25, 118, 210, 0.12)",
    color: "#1565c0",
    borderColor: "rgba(25, 118, 210, 0.35)",
  },
  "&.ops-ready_to_quote": {
    backgroundColor: "rgba(46, 125, 50, 0.12)",
    color: "#2e7d32",
    borderColor: "rgba(46, 125, 50, 0.35)",
  },
  "&.ops-awaiting_customer": {
    backgroundColor: "rgba(251, 192, 45, 0.18)",
    color: "#f9a825",
    borderColor: "rgba(251, 192, 45, 0.45)",
  },
  "&.ops-awaiting_provider": {
    backgroundColor: "rgba(237, 108, 2, 0.12)",
    color: "#ef6c00",
    borderColor: "rgba(237, 108, 2, 0.35)",
  },
  "&.ops-quote_sent": {
    backgroundColor: "rgba(94, 53, 177, 0.12)",
    color: "#5e35b1",
    borderColor: "rgba(94, 53, 177, 0.35)",
  },
  "&.ops-booked": {
    backgroundColor: "rgba(49, 27, 146, 0.14)",
    color: "#311b92",
    borderColor: "rgba(49, 27, 146, 0.4)",
  },
  "&.ops-needs_review": {
    backgroundColor: "rgba(211, 47, 47, 0.12)",
    color: "#c62828",
    borderColor: "rgba(211, 47, 47, 0.35)",
  },
  "&.ops-pending_identity": {
    backgroundColor: "rgba(237, 108, 2, 0.12)",
    color: "#ef6c00",
    borderColor: "rgba(237, 108, 2, 0.35)",
  },
  "&.ops-rejected": {
    backgroundColor: "rgba(158, 158, 158, 0.12)",
    color: "#757575",
    borderColor: "rgba(158, 158, 158, 0.35)",
  },
  "&.ops-unknown": {
    backgroundColor: "rgba(158, 158, 158, 0.12)",
    color: "#757575",
    borderColor: "rgba(158, 158, 158, 0.35)",
  },
});

const OperationalStatusBadge = ({ lead, bucket: bucketProp, size = "small" }) => {
  const bucket = bucketProp || getLeadOperationalBucket(lead);
  if (!bucket) return null;

  const label = getLeadOperationalLabel(bucket);

  return (
    <Tooltip title={label}>
      <StyledChip
        label={label}
        size={size}
        variant="outlined"
        className={`ops-${bucket}`}
      />
    </Tooltip>
  );
};

export default OperationalStatusBadge;
